import { Directive, HostBinding, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[rlResizeLeft]'
})
export class ResizeLeftDirective implements OnInit{

  @Input('rlResizeLeft') group : string;

  @HostBinding('class')
  classes : string;

  constructor() { }

  ngOnInit(): void {
    //this.classes = this.classes ? "middle-content" : this.classes + " middle-content";
  }

}
